// extracted by mini-css-extract-plugin
export default {"container":"_58af0bf","bottomModule":"_c2e8d0cd","popularSearchCategoryTerm":"_759f67ad","topSectionPopularSearches":"_af302087"};